import { Link } from "gatsby";
import React from "react";

var __PATH_PREFIX__;

var Layout = function Layout(_ref) {
  var location = _ref.location,
      title = _ref.title,
      children = _ref.children;
  var rootPath = __PATH_PREFIX__ + "/";
  var isRootPath = location.pathname === rootPath;
  var header;

  if (isRootPath) {
    header = /*#__PURE__*/React.createElement("h1", {
      className: "main-heading"
    }, /*#__PURE__*/React.createElement(Link, {
      to: "/"
    }, title));
  } else {
    header = /*#__PURE__*/React.createElement(Link, {
      className: "header-link-home",
      to: "/"
    }, title);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "global-wrapper",
    "data-is-root-path": isRootPath
  }, /*#__PURE__*/React.createElement("header", {
    className: "global-header"
  }, header), /*#__PURE__*/React.createElement("main", null, children), /*#__PURE__*/React.createElement("footer", null, "\xA9 ", new Date().getFullYear(), ", Built with", " ", /*#__PURE__*/React.createElement("a", {
    href: "https://www.gatsbyjs.com"
  }, "Gatsby")));
};

export default Layout;